import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from "ng-zorro-antd";
import { DialogModule, GrowlModule } from 'primeng/primeng';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CookieModule } from 'ngx-cookie';

import { MissionService } from './../../providers/mission.services';
import { AuthService } from '../../providers/auth.service';
import { BettingService } from "../../services/betting.service";
import { LotteryResolver } from './lottery/lottery.resolver';
import { PagesComponent } from './pages.component';
import { routing } from './pages.routes';
import { SharedModule } from './../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        NgZorroAntdModule,
        ReactiveFormsModule,
        FormsModule,
        DialogModule,
        GrowlModule,
        CookieModule.forRoot(),
        routing,
        SharedModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    declarations: [
        PagesComponent,
    ],
    providers: [
        // appRoutingProviders,
        BettingService,
        // CurrLotteryModel,
        AuthService,
        LotteryResolver,
        MissionService
    ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/pages/pages.module.ts